import { render, staticRenderFns } from "./DateFormatSetting.vue?vue&type=template&id=b3943d44&"
import script from "./DateFormatSetting.vue?vue&type=script&lang=js&"
export * from "./DateFormatSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports